import { DeltaSlippage } from "#/hooks/useDeltaSlippage";
import { type PricesTableEntry } from "#/types/combo";
import { isBuy } from "#/utils/marketActionConverter";

export const getOptionsCreditAndDebit = (
  comboPrices: PricesTableEntry[],
  deltaFactors: DeltaSlippage,
) => {
  let totalDebit = 0;
  let totalCredit = 0;

  let totalDebitWithSlippage = 0;
  let totalCreditWithSlippage = 0;

  for (const instrument of comboPrices) {
    const size = Number(instrument.size);

    if (isNaN(size)) continue;

    const value = size * instrument.estimatedExecutionPrice!;

    if (isBuy(instrument.side!)) {
      totalDebit += value;
    } else {
      totalCredit += value;
    }

    if (instrument?.deltaFactorKey && instrument?.markPrice) {
      const { deltaFactorKey, markPrice } = instrument;
      const netPriceFromMark = size * markPrice;
      if (isBuy(instrument.side!)) {
        totalDebitWithSlippage +=
          netPriceFromMark * (1 + deltaFactors[deltaFactorKey]);
      } else {
        totalCreditWithSlippage +=
          netPriceFromMark * (1 - deltaFactors[deltaFactorKey]);
      }
    }
  }

  const isCredit = totalCredit - totalDebit > 0;
  const net = totalCredit - totalDebit;
  const totalWithSlippage = totalCreditWithSlippage - totalDebitWithSlippage;

  return { totalDebit, totalCredit, isCredit, net, totalWithSlippage };
};
